import {Component, Input, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {AppNameEnum, Organgesellschaft, RechtsformEnumLabels} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';
import {isEmpty} from 'lodash';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-organgesellschaft-form',
    templateUrl: './organgesellschaft-form.component.html'
})
export class OrgangesellschaftFormComponent extends FormBaseComponent<Organgesellschaft> implements OnInit {

    @Input()
    public organgesellschaft: Organgesellschaft;
    public rechtsformenOptions;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                private readonly translateService: TranslateService,
                protected readonly messageService: DatevMessageService,
                protected readonly activatedRoute: ActivatedRoute) {
        super(messageService);
    }

    private static isInvalidBeteiligunsverhaeltnis(zaehler: string, nenner: string): boolean {
        return (isEmpty(nenner) || isEmpty(zaehler) || +zaehler <= +nenner);
    }

    public ngOnInit(): void {

        this.data = this.organgesellschaft;

        this.rechtsformenOptions = [];
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);

        if (appEnum === AppNameEnum.FragebogenEUn || appEnum === AppNameEnum.FragebogenPersG) {
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_310,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_310}`
            });
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_270,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_270}`
            });
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_350,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_350}`
            });
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_230,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_230}`
            });
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_220,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_220}`
            });
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_320,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_320}`
            });
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_210,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_210}`
            });
            this.rechtsformenOptions.push({
                value: RechtsformEnumLabels.NUMBER_991,
                label: `COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.KEY_${RechtsformEnumLabels.NUMBER_991}`
            });
        }

        super.ngOnInit();


    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
                bezeichnung: [this.data.bezeichnung, [
                    this.validatorService.required(),
                    this.validatorService.maxLength(120)
                ]],
                rechtsform: [this.data.rechtsform],
                beteiligungsverhaeltnisZaehler: [
                    this.data.beteiligungsverhaeltnisZaehler,
                    [
                        this.validatorService.conditionTrue(() =>
                                OrgangesellschaftFormComponent.isInvalidBeteiligunsverhaeltnis(this.data.beteiligungsverhaeltnisZaehler,
                                    this.data.beteiligungsverhaeltnisNenner),
                            this.translateService.instant(
                                'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.VALIDATION.ZAEHLER_GROESSER_NENNER')
                        ),
                        this.validatorService.conditionalValidator(() => !isEmpty(this.data.beteiligungsverhaeltnisNenner),
                            this.validatorService.required()),
                        this.validatorService.maxLength(7),
                        this.validatorService.pattern('^[1-9][0-9]*$',
                            this.translateService.instant(
                                'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.VALIDATION.BETEILIGUNGSVERHAELTNIS_ZAEHLER'
                            )
                        )
                    ]
                ],
                beteiligungsverhaeltnisNenner: [this.data.beteiligungsverhaeltnisNenner,
                    [this.validatorService.conditionTrue(() =>
                            OrgangesellschaftFormComponent.isInvalidBeteiligunsverhaeltnis(this.data.beteiligungsverhaeltnisZaehler,
                                this.data.beteiligungsverhaeltnisNenner),
                        this.translateService.instant(
                            'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.VALIDATION.ZAEHLER_GROESSER_NENNER')
                    ),
                        this.validatorService.conditionalValidator(() => !isEmpty(this.data.beteiligungsverhaeltnisZaehler),
                            this.validatorService.required()),
                        this.validatorService.maxLength(7),
                        this.validatorService.pattern('^[1-9][0-9]*$',
                            this.translateService.instant(
                                'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.VALIDATION.BETEILIGUNGSVERHAELTNIS_NENNER'
                            ))
                    ]],
                beteiligungsverhaeltnisUstIdentifikationsnummer: [this.data.beteiligungsverhaeltnisUstIdentifikationsnummer,
                    [
                        this.validatorService.pattern(ValidationPattern.UST_ID,
                            this.translateService.instant('COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.VALIDATION.USTID_PATTERN'))
                    ]],
                beteiligungsverhaeltnisWirtschaftsIdNummer: [this.data.beteiligungsverhaeltnisWirtschaftsIdNummer,
                    [
                        this.validatorService.pattern(ValidationPattern.WIRTSCHAFTS_ID,
                            this.translateService.instant('COMMON_UI.VALIDATION.WIRTSCHAFTS_ID_NUMMER_INVALID_PATTERN'))
                    ]]
            }
        );
    }

}
